import { useEffect, useState } from "react";
import styled from "styled-components";
import queryString from "query-string";
import { useForm } from "react-hook-form";
import { Link, useHistory, useLocation } from 'react-router-dom';
import UniversalInput from "components/Input/UniversalInput";
import MainErrorBox from 'components/error/mainError';
import LoadingButton from "@mui/lab/LoadingButton";
import { getCurrentUser, LoginService } from 'services'
import { saveStorageObject } from 'utils/storage'
import { setAuthorizationToken } from 'services/mainAxios';
import { useDispatch } from "react-redux";
import { setDomain, setToken, setCurrentUser } from "redux/authSlice";
import FormContainerTemplate from "../FormContainer";

import { ReactComponent as ProfestoLogo } from 'assets/svg/profesto_logo.svg';

const Login = (props: any) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorType, setErrorType] = useState<string>('error');
  const [showError, setShowError] = useState<boolean>(false);
  const [errorText, setErrorText] = useState<string>('Please Enter Your Email Address And Password In Order To Log In.');
  const [isPass, setIsPass] = useState(true);
  const dispatch = useDispatch();

  const { register, handleSubmit, watch, setValue, formState: { errors } } = useForm();
  const history = useHistory();
  const watchEmail = watch('email', false);
  const watchPassword = watch('password', false)
  const location = useLocation();
  let params = queryString.parse(location.search);

  const onSubmit = (data: any) => {
    setIsLoading(true);
    setShowError(false);
    LoginService(data.email, data.password, params['c']).then(res => {
      saveStorageObject('token', res.data.token);
      saveStorageObject('refresh_token', res.data.refresh_token);
      setAuthorizationToken(res.data.token);
      dispatch(setToken(res.data.token));
      getCurrentUser().then(res => {
        dispatch(setDomain(res.data.company.id));
        dispatch(setCurrentUser(res.data));
      })
      setTimeout(() => {
        history.push(params.c && params.to ? `/redirect/link?c=${params.c}&to=${params.to}` : '/people');
      }, 100)

    }).catch((err) => {
      setValue('password', '');
      if (err?.response?.data?.errors?.[0].code === 2) {
        setErrorText(err.response.data.errors[0].message);
        setErrorType('warning');
        setShowError(true);
        setIsLoading(false);
      } else if (err?.response?.data?.errors?.[0].code === 3) {
        history.push({
          pathname: '/locked',
          state: { email: data.email }
        });
      } else {
        setErrorText(err.response.data.errors[0].message);
        setErrorType('warning');
        setShowError(true);
        setIsLoading(false);
      }
    })
  };

  useEffect(() => {
    if (props.location && props.location.state && props.location.state.fromUnlock) {
      setErrorText('Your account was successfully unlocked. Please sign in to continue');
      setErrorType('success');
      setShowError(true);
    } else if (props.location && props.location.state && props.location.state.fromReset) {
      setErrorText('Your password was reset successfully');
      setErrorType('success');
      setShowError(true);
    } else if (props.location && props.location.state && props.location.state.fromActivation) {
      setErrorText('Your account was successfully activated');
      setErrorType('success');
      setShowError(true);
    } else if (props.location && props.location.state && props.location.state.fromRecovery) {
      setErrorText("Now, check your email for instructions on resetting your password. If you still can't log in, contact your administrator");
      setErrorType('success');
      setShowError(true);
    } else if (props?.location?.state?.alreadyConfirmed) {
      setErrorText(props.location.state.alreadyConfirmed);
      setErrorType('warning');
      setShowError(true);
    } else if (props?.location?.state?.unlockLinkInvalid) {
      setErrorText(props.location.state.unlockLinkInvalid);
      setErrorType('error');
      setShowError(true);
    }
  }, [props.location])

  useEffect(() => {
    if (errors.email || errors.password) {
      setErrorText('Please Enter Your Email Address And Password In Order To Log In.');
      setErrorType('error');
    }
  }, [errors.email, errors.password]);

  return (
    <FormContainerTemplate>
      <FormTopContainer>
        <ProfestoLogo
          width={274}
          height={56}
          id='profesto_logo'
        />
        <p>Don't have an account? <Link to='signup'>Sign Up</Link></p>
      </FormTopContainer>

      {!!(errors.email || errors.password || showError) && <MainErrorBox
        type={errorType}
        text={errorText.replaceAll("<br/>", "\n")}
      />}

      <form onSubmit={handleSubmit(onSubmit)}>
        <UniversalInput
          placeholder='Email'
          visiblePlaceholder={watchEmail ? true : false}
          size='medium'
          style={{ marginBottom: 22 }}
          {...register("email", { required: true })}
        />
        <UniversalInput
          size='medium'
          placeholder='Password'
          type={isPass ? 'password' : 'text'}
          withEyeAdornment={true}
          onEyeAdornmentClick={() => setIsPass(!isPass)}
          visiblePlaceholder={watchPassword ? true : false}
          style={{ marginBottom: 22 }}
          {...register("password", { required: true })}
        />
        <ForgotPasswordLink to={{ pathname: 'recover', state: { email: watchEmail } }}>Forgot Password?</ForgotPasswordLink>
        <LoadingButton
          loading={isLoading}
          sx={{ marginTop: 3, fontSize: 14, padding: 2 }}
          fullWidth
          variant='contained'
          type="submit"
        >
          Log In
        </LoadingButton>
      </form>
    </FormContainerTemplate>
  );
};

export default Login;

const FormTopContainer = styled.div`
  margin-bottom: 44px;
  text-align: center;
  p {
    color: var(--dark-gray);
    margin-top: 20px;
    & > a {
      font-family: 'Aspira Demi';
      color: var(--green)
    }
  }
`;

const ForgotPasswordLink = styled(Link)`
  color: var(--dark-gray);
  text-decoration: underline;
`;
